import { render } from "./App.vue?vue&type=template&id=34bab342"
import script from "./App.vue?vue&type=script&lang=ts&charset=utf-8"
export * from "./App.vue?vue&type=script&lang=ts&charset=utf-8"

import "./App.vue?vue&type=style&index=0&id=34bab342&lang=scss"
script.render = render

export default script